import { retrieveAllPayments } from "../../../redux/admin-slices/payment.slice"
import TablePagination from "../../../components/common/PaginationSkell"
import EntriesSelect from "../../../components/ui/EntriesSelect"
import TableSkell from "../../../components/common/TableSkell"
import InputFieldA from "../../../components/ui/InputFieldA"
import SelectInput from "../../../components/ui/SelectInput"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect, useRef } from "react"
import { debounce } from "../../../utils/helper"
import moment from "moment"

import {
  Box, Chip, Container, Grid2 as Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography,
} from "@mui/material"

function AllPayments() {
  const searchRef = useRef("")
  const statusRef = useRef("")
  const typeRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const [data, setData] = useState(null)
  const { loadings, refresh } = useSelector((state) => state.otherSlice)

  // Handle retrieve all payments
  const handleRetrieveAll = (filters) => {
    dispatch(
      retrieveAllPayments({
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
        type: typeRef?.current?.value?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data)
      })
      .catch(() => { })
  }

  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [refresh])

  const formatAmount = (amount) => {
    // Assuming amount is in smallest unit (e.g. cents/paise)
    return (amount / 100).toFixed(2)
  }

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Payments</Typography>
      </Box>

      <Grid
        container
        spacing={1}
        className="filters-grid"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            placeholder={"Search by ID or Name..."}
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Status"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="Select a value"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
            options={[
              { name: "All", value: "all" },
              // { name: "Pending", value: "pending" },
              { name: "Succeeded", value: "succeeded" },
              // { name: "Failed", value: "failed" },
              { name: "Refunded", value: "refunded" },
            ]}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={typeRef}
            label="Type"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="Select a value"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
            options={[
              { name: "All", value: "all" },
              { name: "Payment", value: "payment" },
              { name: "Refund", value: "refund" },
              { name: "Partial Refund", value: "partial_refund" },
            ]}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "Payment ID",
                  "Specialist",
                  "Member",
                  "Type",
                  "Amount",
                  "Status",
                  "Payout",
                  "Booking Date"
                ]?.map((cell, i) => (
                  <TableCell key={i} align="left">
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ? (
                <TableSkell colLength={8} />
              ) : (
                data?.records?.map((payment, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{
                      td: {
                        borderBottomWidth:
                          i === data?.records?.length - 1 ? "0" : "1px",
                      },
                    }}
                  >
                    {console.log(payment, "payment")}
                    <TableCell>
                      <Typography sx={{ fontFamily: "monospace", fontSize: "0.85rem" }}>
                        {payment?.paymentIdStr || payment?.stripeSessionId?.substring(0, 16) + '...'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>
                      {payment?.specialistName || 'N/A'}
                    </TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>
                      {payment?.memberName || 'N/A'}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={payment?.paymentType?.replace('_', ' ')}
                        color={
                          payment?.paymentType === "payment"
                            ? "primary"
                            : "secondary"
                        }
                        sx={{
                          fontFamily: "Poppins",
                          textTransform: "capitalize",
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {payment?.currency?.toLowerCase() === "usd" ? "$" : ""}{formatAmount(payment?.amount)}{payment?.currency?.toLowerCase() !== "usd" ? ` ${payment?.currency?.toUpperCase()}` : ""}
                      </Typography>
                      {payment?.totalRefunded > 0 && (
                        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 0.5 }}>
                          Refunded: {payment?.currency?.toLowerCase() === "usd" ? "$" : ""}{formatAmount(payment?.totalRefunded)}{payment?.currency?.toLowerCase() !== "usd" ? ` ${payment?.currency?.toUpperCase()}` : ""}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={payment?.status}
                        color={
                          payment?.status === "succeeded"
                            ? "success"
                            : payment?.status === "pending"
                              ? "warning"
                              : payment?.status === "failed" || payment?.status === "abandoned"
                                ? "error"
                                : "info"
                        }
                        sx={{
                          fontFamily: "Poppins",
                          textTransform: "capitalize",
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={
                          payment?.payoutStatus === "refunded_to_member"
                            ? "Refunded To Member"
                            : payment?.payoutStatus || "held"
                        }
                        sx={{
                          fontFamily: "Poppins",
                          textTransform: "capitalize",
                          minWidth: "60px",
                          color: "#333",
                          backgroundColor: payment?.payoutStatus === "released" ? "success.main" : payment?.payoutStatus === "refunded_to_member" ? "#af263a" : "#4b4848",
                          border: "1px solid",
                          borderColor: payment?.payoutStatus === "released" ? "success.main" : payment?.payoutStatus === "refunded_to_member" ? "#f44336" : "#9e9e9e",
                          fontWeight: 500
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {payment?.bookingDate ? moment(payment?.bookingDate).format("MM-DD-YYYY hh:mm A") : 'N/A'}
                    </TableCell>
                  </TableRow>
                ))
              )}

              {!data?.records?.length && !loadings?.retrieveAll && (
                <TableRow sx={{ td: { borderBottom: "none" } }}>
                  <TableCell colSpan={8}>
                    <Typography variant="noRecords">
                      No results found!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
          cb={handleRetrieveAll}
          limit={entriesRef?.current?.value || 10}
        />
      </Box>
    </Container>
  )
}

export default AllPayments
